import React, { useState } from 'react';

interface Props {
  order: string | null;
  keyword: string | null;
  onChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickOrder: (order: string | null) => void;
  onClickKeywordSearch: () => void;
}

export default function MobileSelector({
  order,
  keyword,
  onChangeKeyword,
  onClickOrder,
  onClickKeywordSearch,
}: Props) {
  const [checked, setChecked] = useState(false);

  const onClickSearchToggle = () => {
    setChecked(!checked);
  };

  const resetKeyword = (fn: () => void) => {
    onChangeKeyword({
      target: { value: '' },
    } as React.ChangeEvent<HTMLInputElement>);
    setChecked(false);
    fn();
  };

  const resetFilter = (fn: () => void) => {
    onClickOrder(null);
    fn();
  };

  return (
    <React.Fragment>
      <div className="g-filter">
        <div className="list-group list-group-horizontal project-selector__navi">
          <a
            href="#"
            className="navi-item__wrapper"
            onClick={e => {
              e.preventDefault();
              resetKeyword(() => onClickOrder('in_progress'));
            }}
          >
            <div
              className={`list-group-item navi-item ${
                order === 'in_progress' ? 'active' : ''
              }`}
            >
              新着順
            </div>
          </a>
          <a
            href="#"
            className="navi-item__wrapper"
            onClick={e => {
              e.preventDefault();
              resetKeyword(() => onClickOrder('amount'));
            }}
          >
            <div
              className={`list-group-item navi-item ${
                order === 'amount' ? 'active' : ''
              }`}
            >
              人気順
            </div>
          </a>
          <a
            href="#"
            className="navi-item__wrapper"
            onClick={e => {
              e.preventDefault();
              resetKeyword(() => onClickOrder(null));
            }}
          >
            <div
              className={`list-group-item navi-item ${
                order === null || order === undefined ? 'active' : ''
              }`}
            >
              全て
            </div>
          </a>
        </div>
        <div className="search-icon__wrapper" onClick={onClickSearchToggle}>
          <span className={`search-icon ${checked ? 'is-checked' : ''}`} />
        </div>
      </div>
      <div className={`search-container ${checked ? 'is-checked' : ''}`}>
        <input
          type="text"
          placeholder="キーワードで検索"
          value={keyword ?? ''}
          onChange={onChangeKeyword}
        />
        <button onClick={() => checked && resetFilter(onClickKeywordSearch)}>
          検索
        </button>
      </div>
    </React.Fragment>
  );
}
